import React from "react";
import { connect } from "react-redux";
import ReactGA from "react-ga";
import { NavLink, withRouter } from "react-router-dom";
import { message, setCurrentShow, setHistoryRoute, setRoute, setTitleAndScrollToTop } from "../../../actions";
import { createQuestionnaires, deleteQuestionnaires, getQuestionnaires, patchQuestionnaires } from "../actions/Questionnaires";

import Form from "../../../components/Form";
import Documents from "./Documents";
import Configuration, { translations } from "../../../config";
import { createBlocks } from "../actions/Blocks";
import Icon from "../../../components/Icon";
import Access from "../../../components/Access";
import TextEditor from "../components/TextEditor";
import QuestionnaireEditor from "../components/QuestionnaireEditor";

const mapStateToProps = ( state ) =>
{
	return {
		route: state.route,
		show: state.show,
		questionnaires: state.questionnaires,
		questions: state.questions,
		blocksByQuestionnaireId: state.blocksByQuestionnaireId
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		resetRoute: () =>
		{
			dispatch( setRoute( null ) );
		},
		postBlocks: ( block, questionnaire_id ) =>
		{
			dispatch( createBlocks( block, questionnaire_id ) );
		},
		getQuestionnaires: ( id ) =>
		{
			dispatch( getQuestionnaires( id ) );
		},
		postQuestionnaires: ( formData ) =>
		{
			dispatch( createQuestionnaires( formData ) );
		},
		patchQuestionnaires: ( formData ) =>
		{
			dispatch( patchQuestionnaires( formData ) );
		},
		deleteQuestionnaires: ( id ) =>
		{
			dispatch( deleteQuestionnaires( id ) );
		},
		setTitleAndScrollToTop: ( title ) =>
		{
			dispatch( setTitleAndScrollToTop( title ) );
		},
		setCurrentShow: ( show ) =>
		{
			dispatch( setCurrentShow( show ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		},
		setHistoryRoute: ( a_route ) =>
		{
			dispatch( setHistoryRoute( a_route ) );
		}
	};
};

/**
 * Fragebogenkomponente der GUI
 */
class Questionnaires extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			longDescription: null,
			isExpand: true
		};
		
		this.handleSubmit = this.handleSubmit.bind( this );
		this.checkQuestionnaire = this.checkQuestionnaire.bind( this );
		this.handleEditLongDescription = this.handleEditLongDescription.bind( this );
		
	} // function constructor(...)
	
	componentDidMount()
	{
		if ( this.props.id !== undefined )
		{
			this.props.setCurrentShow( "editQuestionnaire" );
			this.props.getQuestionnaires( this.props.id );
			
			// Google Analytics
			if ( localStorage.getItem( "ga" ) )
			{
				ReactGA.pageview( `${translations.de_DE.routes.questionnaire}/${this.props.id}` );
			}
		}
		else
		{
			this.props.setTitleAndScrollToTop( `${translations.de_DE.words.questionnaire} erstellen` );
			this.props.setCurrentShow( "createQuestionnaire" );
			
			// Google Analytics
			if ( localStorage.getItem( "ga" ) )
			{
				ReactGA.pageview( `${translations.de_DE.routes.questionnaires}` );
			}
		}
		
	} // function componentDidMount()
	
	componentDidUpdate( a_prevProps )
	{
		const { location, questionnaires, id } = { ...this.props };
		const { pathname } = { ...location };
		
		if ( a_prevProps.route !== null && a_prevProps.route !== pathname )
		{
			this.props.history.push( a_prevProps.route );
			this.props.resetRoute();
		}
		
		if ( questionnaires.hasOwnProperty( id ) && this.state.longDescription === null )
		{
			this.setState( {
				longDescription: questionnaires[id].long_description !== null
					? questionnaires[id].long_description
					: ""
			} );
		}
		
	} // componentDidUpdate(...)
	
	handleSubmit( event, formData, mode )
	{
		switch ( mode )
		{
			case "create":
				let valid = true;
				
				// Pflichtfelder prüfen
				if ( formData.title.length === 0 )
				{
					this.props.message( "Bitte den Titel eingeben.", "warning", 5000 );
					valid = false;
				}
				if ( formData.price <= 0 )
				{
					this.props.message( "Bitte einen gültigen Preis eingeben.", "warning", 5000 );
					valid = false;
				}
				if ( valid )
				{
					if ( this.state.longDescription !== null )
					{
						this.props.postQuestionnaires( { ...formData, long_description: this.state.longDescription } );
					}
					else
					{
						this.props.postQuestionnaires( formData );
					}
				}
				break;
			
			case "edit":
				this.props.patchQuestionnaires( { ...formData, long_description: this.state.longDescription } );
				break;
			
			case "delete":
				this.props.deleteQuestionnaires( formData.id );
				break;
			
			default:
				break;
		}
		
		event.preventDefault();
		
	} // function handleSubmit(...)
	
	checkQuestionnaire( event )
	{
		const { questionnaires, questions, id } = { ...this.props };
		
		// Wenn keine Fragen vorliegen ist die Form nicht valide
		if ( typeof questions === "undefined" || Object.keys( questions[id] ).length === 0 )
		{
			this.props.message( "Die Aktivierung ist nicht möglich, da keine Fragen definiert wurden.", "error" );
			event.preventDefault();
			return false;
		}
		
		// Überprüft ob ein Preis eingetragen ist
		if ( !questionnaires[id].price && event.target.checked )
		{
			this.props.message( "Die Aktivierung ist nicht möglich, da kein Preis eingegeben wurde.", "error" );
			event.preventDefault();
			return false;
		}
		
		// Überprüfe alle Fragen auf Vollständigkeit
		const valid = !Object.keys( questions[id] ).filter(
			( a_key ) =>
			{
				// Wenn eine Frage unvollständige Antworten beinhaltet
				const incompleteAnswers = questions[id][a_key].hasOwnProperty( "answers" ) ? Object.keys( questions[id][a_key]["answers"] ).filter(
					( key ) =>
						( questions[id][a_key]["answers"][key].next_question_id !== null && questions[id][a_key]["answers"][key].result_text !== null )
				) : [];
				
				// Wenn eine Frage keine oder unvollständige Antworten beinhaltet
				return Object.keys( questions[id][a_key]["answers"] ).length < 2 || incompleteAnswers.length > 0;
			}
		).length;
		
		if ( !valid )
		{
			this.props.message( "Die Aktivierung ist nicht möglich, da nicht alle Folgeaktionen definiert wurden.", "error" );
			event.preventDefault();
		}
		else if ( event.target.checked )
		{
			// Fragebogen aktivieren
			this.props.patchQuestionnaires( { ...questionnaires[id], active: "1" } );
		}
		else
		{
			// Fragebogen deaktivieren
			this.props.patchQuestionnaires( { ...questionnaires[id], active: "0" } );
		}
		
		return valid;
		
	} // function checkQuestionnaire(...)
	
	/**
	 * Langbeschreibung merken
	 */
	handleEditLongDescription( event )
	{
		this.setState( { longDescription: event } );
		
	} // function handleEditLongDescription(...)
	
	handleExpand()
	{
		this.setState( { isExpand: !this.state.isExpand } );
		
	} // function handleExpand(...)
	
	render()
	{
		const { id, questionnaires, show } = { ...this.props };
		
		const editorProps = {};
		if ( questionnaires.hasOwnProperty( id ) && questionnaires[id].long_description )
		{
			editorProps["content"] = questionnaires[id].long_description;
		}
		
		return <article>
			{
				show === "createQuestionnaire" &&
				<Access permissions={[ "create_questionnaire" ]}>
					<section className={"white unset-padding"}>
						<div className={"col s12"}>
							<div className={"table"}>
								<div className={"col s12"}>
									<h4>{translations.de_DE.words.questionnaire}</h4>
								</div>
								<Form
									id={`form-new-questionnaire`}
									
									submitValue={[
										<Icon key={`form-new-questionnaire-icon`} iconName={"add"}/>,
										<span key={`form-new-questionnaire-text`}>{translations.de_DE.words.questionnaire} erstellen</span>
									]}
									className="col s12"
									onSubmit={( event, formData ) => this.handleSubmit( event, formData, "create" )}
									fields={[
										{
											name: "title",
											title: "Titel",
											type: "text",
											required: true,
											className: "col s12 m4 l6",
											maxLength: "40"
										},
										{
											name: "law",
											title: "Norm",
											type: "text",
											className: "col s12 m4 l3",
											maxLength: "40"
										},
										{
											name: "price",
											title: "Preis pro Recherche zzgl. 19% USt. (Euro)",
											type: "number",
											step: "0.0001",
											required: true,
											className: "col s12 m4 l3",
											maxLength: "40",
											validator: ( a_value ) =>
											{
												if ( a_value.length <= 0 )
												{
													return false;
												}
												else if ( !Configuration.currencyRegex.test( a_value ) )
												{
													this.props.message( "Der Recherchenpreis darf höchstens 4 Nachkommastellen enthalten." );
													return false;
												}
												
												this.setState( { price: a_value } );
												
												return true;
											}
											
										},
										{
											name: "description",
											title: "Beschreibung",
											type: "textarea",
											className: "col s12",
											required: true,
											maxLength: "255"
										},
										{
											name: "long_description",
											title: "Langbeschreibung",
											type: "hidden",
											additionalHtml: <div className={"col s12"}>
												<label>Langbeschreibung:</label>
												<TextEditor modal
												            onSubmit={( a_html ) => this.handleEditLongDescription( a_html )}
												            trigger={
													            <div className='text-input editorIcon'>
														            <div dangerouslySetInnerHTML={{
															            __html: this.state.longDescription
														            }}/>
													            </div>
												            }
												            {...editorProps}
												/>
											</div>,
											cleared: true
										}
									]}
								/>
							</div>
						</div>
					</section>
				</Access>
			}
			{
				show === "editQuestionnaire" &&
				<Access permissions={[ "patch_questionnaire" ]}>
					{
						!this.state.isExpand
							? <section className={"white unset-padding hiddenDocuments"}>
								<div className={"col s12"}>
									<h4 className={"col s8 margin-top"}>Imera</h4>
									<div className={"actions actions-right"}>
										<button className="btn btn-small btn-flat transparent right"
										        onClick={() => this.handleExpand()}>
											<Icon iconName={this.state.isExpand ? "shrink" : "expand"}/>
										</button>
									</div>
								</div>
							</section>
							: <section className={"white unset-padding"}>
								<div className={"actions actions-right"}>
									<button className="btn btn-small btn-flat transparent right"
									        onClick={() => this.handleExpand()}>
										<Icon iconName={this.state.isExpand ? "shrink" : "expand"}/>
									</button>
								</div>
								<div className={"col s12"}>
									<div className={"col s12"}>
										<h4>{translations.de_DE.words.questionnaire}</h4>
									</div>
									{
										questionnaires.hasOwnProperty( id ) &&
										<Form
											id={`form-questionnaire-${id}`}
											
											submitValue={[
												<Icon key={`form-questionnaire-${id}-icon`} size={18} verticalAlign={"sub"} iconName={"save"}/>,
												<span key={`form-questionnaire-${id}-text`}>Metadaten speichern</span>
											]}
											className="col s12 m7 pull-m5 submitButtonSpace"
											onSubmit={( event, formData ) => this.handleSubmit( event, formData, "edit" )}
											fields={[
												{
													name: "title",
													title: "Titel",
													type: "text",
													required: true,
													className: "col s12 m7 xl8",
													maxLength: "40"
												},
												{
													name: "law",
													title: "Norm",
													type: "text",
													className: "col s12 m5 xl4",
													maxLength: "40"
												},
												{
													name: "description",
													title: "Beschreibung",
													type: "textarea",
													required: true,
													className: "col s12 m5",
													maxLength: "255"
												},
												{
													name: "long_description",
													title: "Langbeschreibung",
													type: "hidden",
													additionalHtml: <div className={"col s12 m4 input-height"}>
														<label>Langbeschreibung:</label>
														<TextEditor modal
														            onSubmit={( a_html ) => this.handleEditLongDescription( a_html )}
														            trigger={
															            <div className='text-input editorIcon'>
																            <div dangerouslySetInnerHTML={{
																	            __html: this.state.longDescription
																            }}/>
															            </div>
														            }
														            {...editorProps}
														/>
													</div>
												},
												{
													name: "price",
													title: "Preis pro Recherche zzgl. 19% USt. (Euro)",
													type: "number",
													step: "0.0001",
													required: true,
													className: "col s12 m3",
													maxLength: "40",
													validator: ( a_value ) =>
													{
														if ( a_value.length > 0 && !Configuration.currencyRegex.test( a_value ) )
														{
															this.props.message( "Der Recherchenpreis darf höchstens 4 Nachkommastellen enthalten." );
															return false;
														}
														
														this.setState( { price: a_value } );
														
														return true;
													},
													cleared: true
													
												},
												{
													name: "active",
													title: `${translations.de_DE.words.questionnaire} ${questionnaires[id] && questionnaires[id].active === "1" ? "de" : ""}aktivieren?`,
													options: `${translations.de_DE.words.questionnaire} ${questionnaires[id] && questionnaires[id].active === "1" ? "de" : ""}aktivieren?`,
													type: "checkbox",
													className: "col s12 m5 push-m7 tRight",
													reverse: true,
													checkboxType: "filled-in",
													onChecked: ( event ) => this.checkQuestionnaire( event ),
													additionalHtml: <NavLink title={`${translations.de_DE.words.questionnaire} testen`}
													                         className={`btn btn-middle margin-top`}
													                         onClick={() => this.props.setHistoryRoute( this.props.location.pathname )}
													                         to={`${translations.de_DE.routes.surveyTest}?id=${id}`}>
														<Icon iconName={"test"}/>
														<span>{`${translations.de_DE.words.questionnaire} testen`}</span>
													</NavLink>
												}
											]}
											values={questionnaires[id]}
										/>
									}
								</div>
							</section>
					}
					<Documents questionnaireId={id}/>
				</Access>
			}
			{
				questionnaires.hasOwnProperty( id ) &&
				<Access permissions={[ "create_questionnaire", "patch_questionnaire" ]}>
					<QuestionnaireEditor questionnaireId={id}/>
				</Access>
			}
		</article>;
		
	} // function render()
	
} // class

Questionnaires = connect(
	mapStateToProps,
	mapDispatchToProps
)( Questionnaires );

export default withRouter( Questionnaires );